export const sortTermsAscending = (terms) => {
  return terms.sort((a, b) => {
    if (a.start_at === null || b.start_at === null) {
      if (a.start_at === null && b.start_at === null) return 0; // Both are null, no change in order
      return a.start_at === null ? -1 : 1; // One is null, place it at the end
    }
    return a.start_at.localeCompare(b.start_at);
  });
};

export const sortTermsDescending = (terms) => {
  return terms.sort((a, b) => {
    if (a.start_at === null || b.start_at === null) {
      if (a.start_at === null && b.start_at === null) return 0; // Both are null, no change in order
      return a.start_at === null ? 1 : -1; // One is null, place it at the end
    }
    return b.start_at.localeCompare(a.start_at);
  });
};

export const getEarliestCanvasTerm = (insightsTerm) => {
  if (!!insightsTerm.canvas_terms && insightsTerm.canvas_terms.length > 0) {
    return insightsTerm.canvas_terms.sort(
      (a, b) => new Date(a.start_at) - new Date(b.start_at)
    )[0];
  } else {
    return undefined;
  }
};
